import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DOSHA_QUESTIONS, DOSHA_RESULTS } from '../data/content';

export default function DoshaQuiz() {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [result, setResult] = useState(null);

  const handleNext = () => {
    const newAnswers = [...answers, selected];
    if (step < DOSHA_QUESTIONS.length - 1) { setAnswers(newAnswers); setSelected(null); setStep(step + 1); }
    else {
      const counts = [0, 0, 0];
      newAnswers.forEach(a => counts[a]++);
      const winner = counts.indexOf(Math.max(...counts));
      setResult(['Vata', 'Pitta', 'Kapha'][winner]);
    }
  };

  const reset = () => { setStep(0); setAnswers([]); setSelected(null); setResult(null); };
  const progress = (step / DOSHA_QUESTIONS.length) * 100;
  const info = result ? DOSHA_RESULTS[result] : null;
  const msg = result ? encodeURIComponent(`Hello Dr. Monika! 🌿\nI just took the Dosha Quiz at Vaidyam Ayurveda and my result is ${result} Prakriti.\nI would like to book a personalised ${result} consultation.\nPlease let me know the available slots. Thank you!`) : '';

  const doshaColors = { Vata: '#7B68EE', Pitta: '#C8941A', Kapha: '#4A9E6B' };
  const doshaBgs = { Vata: 'rgba(123,104,238,0.08)', Pitta: 'rgba(200,148,26,0.08)', Kapha: 'rgba(74,158,107,0.08)' };

  return (
    <div style={{ background: '#1E1108', paddingTop: '68px', minHeight: '100vh' }}>
      <div style={{ maxWidth: '760px', margin: '0 auto', padding: '60px 32px 100px' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <div style={{ fontSize: '52px', marginBottom: '12px' }}>🔮</div>
          <span style={{ fontSize: '10px', letterSpacing: '3px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 500, display: 'block', marginBottom: '12px' }}>Ayurvedic Assessment</span>
          <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '48px', color: '#F0E6D8', marginBottom: '14px', lineHeight: 1.1 }}>Discover Your Dosha</h1>
          <p style={{ fontSize: '15px', color: 'rgba(240,230,216,0.5)', lineHeight: 1.8, maxWidth: '500px', margin: '0 auto' }}>8 questions to reveal your Ayurvedic body type — get personalised diet, lifestyle, and treatment recommendations.</p>
        </div>

        {/* Card */}
        <div style={{ background: '#0E0A06', borderRadius: '8px', border: '1px solid rgba(200,148,26,0.2)', padding: '44px', boxShadow: '0 8px 48px rgba(0,0,0,0.4)' }}>
          {!result ? (
            <>
              {/* Progress */}
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span style={{ fontSize: '13px', color: '#C8941A', fontWeight: 500 }}>Question {step + 1} of {DOSHA_QUESTIONS.length}</span>
                <span style={{ fontSize: '13px', color: 'rgba(240,230,216,0.4)' }}>{Math.round(progress)}% complete</span>
              </div>
              <div style={{ height: '3px', background: 'rgba(255,255,255,0.08)', borderRadius: '2px', marginBottom: '36px', overflow: 'hidden' }}>
                <div style={{ height: '100%', width: progress + '%', background: 'linear-gradient(90deg, #C8941A, #E8B84B)', borderRadius: '2px', transition: 'width 0.4s ease' }} />
              </div>

              {/* Question */}
              <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '26px', color: '#F0E6D8', marginBottom: '28px', lineHeight: 1.4 }}>{DOSHA_QUESTIONS[step].q}</h2>

              {/* Options */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '32px' }}>
                {DOSHA_QUESTIONS[step].opts.map((opt, i) => (
                  <button key={i} onClick={() => setSelected(i)} style={{
                    background: selected === i ? 'rgba(200,148,26,0.15)' : 'rgba(0,0,0,0.3)',
                    border: selected === i ? '1px solid rgba(200,148,26,0.6)' : '1px solid rgba(255,255,255,0.08)',
                    borderRadius: '4px', padding: '15px 20px', textAlign: 'left',
                    fontSize: '15px', color: selected === i ? '#F0E6D8' : 'rgba(240,230,216,0.6)',
                    cursor: 'pointer', transition: 'all 0.2s', fontFamily: 'DM Sans, sans-serif',
                    display: 'flex', alignItems: 'center', gap: '14px',
                  }}>
                    <div style={{ width: '20px', height: '20px', borderRadius: '50%', border: selected === i ? '2px solid #C8941A' : '1px solid rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'all 0.2s' }}>
                      {selected === i && <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#C8941A' }} />}
                    </div>
                    {opt}
                  </button>
                ))}
              </div>

              {/* Nav buttons */}
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <button onClick={() => { setStep(Math.max(0, step - 1)); setAnswers(answers.slice(0, -1)); setSelected(null); }} disabled={step === 0}
                  style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '3px', padding: '11px 22px', fontSize: '13px', color: 'rgba(240,230,216,0.4)', cursor: step === 0 ? 'not-allowed' : 'pointer', opacity: step === 0 ? 0.4 : 1, fontFamily: 'DM Sans, sans-serif' }}>← Back</button>
                <button onClick={handleNext} disabled={selected === null}
                  style={{ background: selected !== null ? '#C8941A' : 'rgba(255,255,255,0.06)', color: selected !== null ? '#120800' : 'rgba(240,230,216,0.25)', border: 'none', borderRadius: '3px', padding: '11px 28px', fontSize: '13px', fontWeight: 500, cursor: selected !== null ? 'pointer' : 'not-allowed', transition: 'all 0.2s', fontFamily: 'DM Sans, sans-serif' }}>
                  {step === DOSHA_QUESTIONS.length - 1 ? 'See My Dosha →' : 'Next →'}
                </button>
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '60px', marginBottom: '12px' }}>{info.emoji}</div>
              <div style={{ fontSize: '10px', letterSpacing: '3px', textTransform: 'uppercase', color: doshaColors[result], fontWeight: 600, marginBottom: '8px' }}>Your Prakriti is</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '54px', fontWeight: 400, color: '#F0E6D8', marginBottom: '6px' }}>{result}</div>
              <div style={{ fontSize: '13px', color: 'rgba(200,148,26,0.7)', marginBottom: '6px' }}>{info.element}</div>
              <div style={{ fontSize: '15px', color: 'rgba(240,230,216,0.55)', marginBottom: '32px', fontStyle: 'italic' }}>{info.traits}</div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', textAlign: 'left', marginBottom: '28px' }}>
                {[
                  ['⚡ When Imbalanced', info.imbalance],
                  ['🥗 Ideal Foods', info.foods],
                  ['🌿 Recommended Herbs', info.herbs],
                  ['🌅 Daily Routine', info.routine],
                ].map(([title, val]) => (
                  <div key={title} style={{ background: 'rgba(0,0,0,0.3)', borderRadius: '4px', padding: '16px 18px', border: `1px solid ${doshaColors[result]}20` }}>
                    <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1.5px', color: doshaColors[result], fontWeight: 600, marginBottom: '6px' }}>{title}</div>
                    <div style={{ fontSize: '14px', color: 'rgba(240,230,216,0.7)', lineHeight: 1.7 }}>{val}</div>
                  </div>
                ))}

                <div style={{ background: 'rgba(0,0,0,0.3)', borderRadius: '4px', padding: '16px 18px', border: `1px solid ${doshaColors[result]}20` }}>
                  <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1.5px', color: doshaColors[result], fontWeight: 600, marginBottom: '10px' }}>Recommended Therapies at Vaidyam</div>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {info.treatments.map(t => (
                      <span key={t} style={{ fontSize: '12px', color: doshaColors[result], background: `${doshaColors[result]}15`, padding: '5px 13px', borderRadius: '2px', border: `1px solid ${doshaColors[result]}30`, fontWeight: 500 }}>{t}</span>
                    ))}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <a href={`https://wa.me/919425706830?text=${msg}`} target="_blank" rel="noreferrer" className="btn-gold">Book {result} Consultation →</a>
                <button onClick={reset} className="btn-ghost">Retake Quiz</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
